<div role="banner" class="appbar">
  <!-- product logo -->
   <div>
    <div class="appbar__product-logo d-none d-md-block">
      <img class="image image--responsive" src="/assets/theme/logo-product.png" />      
    </div>
    <!-- Mobile profile details -->
    <div class="profile__details_mobile d-md-none">
      <div class="profile__name">{{ userFullName }}</div>
      <div class="profile__email">{{ userEmail }}</div>
    </div>
   </div>
  

  <!-- search -->
  <div class="appbar__search">
    <!-- TODO: search input + results dropdown [ future release ] -->
  </div>

  <!-- content -->
  <div class="appbar__content">
    <!-- TODO: change utils to style lib utils [ future release ] -->
    <div class="appbar__date d-none d-md-block">
      {{ currentDate | date : 'EEEE, d MMMM y' }}
    </div>

    <!-- TODO: link/btns + states [ future release ] -->
    <div class="appbar__actions d-none d-md-block">
      <lds-tooltip message="task list" placement="bottom">
        <lds-icon name="tasks" (click)="goToTasks()"></lds-icon>
      </lds-tooltip>
    </div>

    <div class="appbar__account">
      <div class="profile">
        <!-- TODO: change utils to style lib utils [ future release ] -->
        <div class="profile__details d-none d-md-block">
          <div class="profile__name">{{ userFullName }}</div>
          <div class="profile__role">
            {{ adviserLabelCase.TitleCase | adviserRole }}
          </div>
          <div class="profile__email">{{ userEmail }}</div>
        </div>

        <div class="profile__avatar">
          <lds-avatar [name]="userFullName"></lds-avatar>
        </div>

        <!-- TODO: link/btns + states [ future release ] -->
        <div class="profile__actions">
          <lds-tooltip message="sign out" placement="bottom">
            <lds-icon name="sign-out" (click)="showConfirm()"></lds-icon>
          </lds-tooltip>
        </div>
      </div>
    </div>
  </div>
</div>
